import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Building, Mail, Phone, CheckCircle } from "lucide-react";

export function SchoolInfoTab({ school }) {
  return (
    <div className="space-y-6">
      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building className="w-5 h-5 text-emerald-600" />
            School Information
          </CardTitle>
          <CardDescription>Basic details about your school</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label className="text-slate-500 text-sm">School Name</Label>
              <p className="font-medium text-slate-800">{school?.name || "-"}</p>
            </div>
            <div>
              <Label className="text-slate-500 text-sm">School Code</Label>
              <p className="font-medium text-slate-800 font-mono">{school?.school_code || "-"}</p>
            </div>
            <div>
              <Label className="text-slate-500 text-sm">Board</Label>
              <p className="font-medium text-slate-800">{school?.board || "-"}</p>
            </div>
            <div>
              <Label className="text-slate-500 text-sm">School Type</Label>
              <p className="font-medium text-slate-800 capitalize">{school?.type || "-"}</p>
            </div>
            <div>
              <Label className="text-slate-500 text-sm">State</Label>
              <p className="font-medium text-slate-800">{school?.state || "-"}</p>
            </div>
            <div>
              <Label className="text-slate-500 text-sm">City</Label>
              <p className="font-medium text-slate-800">{school?.city || "-"}</p>
            </div>
            <div>
              <Label className="text-slate-500 text-sm">Address</Label>
              <p className="font-medium text-slate-800">
                {school?.address 
                  ? (typeof school.address === 'string' 
                      ? school.address 
                      : [school.address.line1, school.address.line2, school.address.area, school.address.city, school.address.state, school.address.pincode]
                          .filter(Boolean)
                          .join(", ")
                    ) || "-"
                  : "-"
                }
              </p>
            </div>
            <div>
              <Label className="text-slate-500 text-sm">Verification Status</Label>
              <Badge className={school?.status === "verified" 
                ? "bg-green-100 text-green-700" 
                : "bg-amber-100 text-amber-700"
              }>
                {school?.status === "verified" ? (
                  <><CheckCircle className="w-3 h-3 mr-1" /> Verified</>
                ) : (
                  school?.status || "Pending"
                )}
              </Badge>
            </div>
          </div>

          <div className="pt-4 border-t border-slate-100">
            <Label className="text-slate-500 text-sm">Grades Offered</Label>
            <div className="flex flex-wrap gap-2 mt-2">
              {(school?.grades_offered || []).map(grade => (
                <Badge key={grade} variant="secondary">Grade {grade}</Badge>
              ))}
            </div>
          </div>

          <div className="pt-4 border-t border-slate-100">
            <Label className="text-slate-500 text-sm">Contact Information</Label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
              <div className="flex items-center gap-2 text-slate-600">
                <Mail className="w-4 h-4" />
                <span>{school?.official_email || "-"}</span>
              </div>
              <div className="flex items-center gap-2 text-slate-600">
                <Phone className="w-4 h-4" />
                <span>{school?.phone || "-"}</span>
              </div>
            </div>
          </div>

          <p className="text-xs text-slate-400 pt-4">
            Contact support to update school information.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
